
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/store-landing",
      function () {
        return require("private-next-pages/india/store-landing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/india/store-landing"])
      });
    }
  